import RegexpPatterns from "./RegexpPatterns";

export const getEmailSchemaValidator = () => ({
    type: "string",
    pattern: RegexpPatterns.EMAIL,
    maxLength: 100,
});
